import React, { useEffect, useState } from 'react'
import Try from './Try'
import Navbar from '../Components/NavBar'
import Layout from '../Components/Layout'
import HomeComponents from '../Components/HomeComponents'
import Aboutme from '../Components/Aboutme'
import MyProjects from '../Components/MyProjects' // Using fast MyProjects
import MySkills from '../Components/MySkills'
import ExperienceCards from '../Components/ExperienceCards' // Using fast Tabbed Experience
import ContactForm from '../Components/ContactForm'
import EducationQualifications from '../Components/timeline/EducationQualifications'
import profile from '../images/profilepic.jpg'
import { FaDownload } from 'react-icons/fa'
import { CSSTransition } from 'react-transition-group'
import '../transition.css'

const Section = ({ id, children, className = "" }) => (
  <section id={id} className={`min-h-screen py-20 px-4 flex flex-col justify-center ${className}`}>
    {children}
  </section>
);

const HomePage = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Layout title="Sarvadnya || Portfolio">
      <div className="relative bg-black">
        {/* Fixed Background */}
        <Try />

        {/* Navigation - Passed isHome prop to enable scroll links */}
        <Navbar isHome={true} />

        {/* Main Content */}
        <div className="relative z-10 w-full text-white">

          {/* Home Section */}
          <section id="home">
            <CSSTransition in={mounted} timeout={1500} classNames='custom'>
              <HomeComponents />
            </CSSTransition>
          </section>

          {/* About Section */}
          <Section id="about">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h1 className="text-5xl font-bold font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600 inline-block">
                  ABOUT ME
                </h1>
                <div className="h-1 w-24 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full mt-2"></div>
              </div>
              <div className="flex flex-col lg:flex-row items-center justify-center gap-12">
                <div className="w-full lg:w-1/3 flex flex-col items-center">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src={profile}
                      alt="Sarvadnya Awaghad"
                      className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full object-cover border-4 border-black/50 shadow-2xl transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <a
                    href="/resume.pdf"
                    download="Sarvadnya_Awaghad_CV.pdf"
                    className="mt-8 px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-bold shadow-lg hover:shadow-purple-500/50 hover:-translate-y-1 transition-all duration-300 flex items-center gap-2"
                  >
                    <FaDownload /> Download Resume
                  </a>
                </div>
                <div className="w-full lg:w-2/3">
                  <Aboutme />
                </div>
              </div>
            </div>

            <div className="mt-20">
              <EducationQualifications />
            </div>
          </Section>

          {/* Projects Section - Loaded statically for speed */}
          <Section id="projects">
            <MyProjects />
          </Section>

          {/* Skills Section */}
          <Section id="skills">
            <MySkills />
          </Section>

          {/* Experience Section - Using restored Tab components */}
          <Section id="experience">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-16">
                <h2 className="text-5xl font-bold mb-4 font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600 inline-block">
                  WORK EXPERIENCE
                </h2>
                <div className="h-1 w-24 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
              </div>
              <ExperienceCards />
            </div>
          </Section>

          {/* Contact Section */}
          <Section id="contact">
            <ContactForm />
          </Section>

        </div>
      </div>
    </Layout>
  )
}

export default HomePage